"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("styled-components");
const styled = __importStar(require("./styled"));
const Typography_1 = __importStar(require("@/Components/UI/Typography"));
const ProductLogo_1 = __importDefault(require("@/Components/UI/ProductLogo"));
const AddToCartWrapper_1 = __importDefault(require("./AddToCartWrapper/AddToCartWrapper"));
const RotatingLoader_1 = __importDefault(require("@/Components/UI/RotatingLoader/RotatingLoader"));
const ProductImage_1 = __importDefault(require("@/Components/UI/ProductImage"));
const ProductCompare_utils_1 = require("./ProductCompare.utils");
const Hooks_1 = require("@/Hooks");
const ProductCompare = ({ compareProducts, setCompareProducts, setCompareProductPartNumbers, setListingPageState, isCompareLoading }) => {
    const { t } = (0, Hooks_1.useTranslate)();
    const theme = (0, styled_components_1.useTheme)();
    const propertyKeys = [];
    compareProducts.forEach(product => {
        const { publicProperties, privateProperties } = product;
        publicProperties.concat(privateProperties).forEach(prop => {
            if (!propertyKeys.includes(prop.key)) {
                propertyKeys.push(prop.key);
            }
        });
    });
    const columnsNumber = compareProducts.length + 1;
    const deleteProductFromCompare = (partNumber) => {
        setCompareProductPartNumbers(prev => prev.filter(el => el !== partNumber));
        setCompareProducts(prev => prev.filter(el => el.partNumber !== partNumber));
    };
    return (react_1.default.createElement(styled.Container, null,
        react_1.default.createElement(styled.PageTitle, { type: Typography_1.Types.H1 }, t('/haldex/product_page/compare/compare_products')),
        react_1.default.createElement(styled.BackButton, { onClick: setListingPageState },
            react_1.default.createElement(styled.BackArrow, { stroke: theme.palette.BLUE_100 }),
            react_1.default.createElement(Typography_1.default, { type: Typography_1.Types.INTRODUCTORY_TEXT, color: theme.palette.BLUE_100 }, t('/haldex/product_page/compare/back_to_product_list'))),
        isCompareLoading ? (react_1.default.createElement(styled.LoadingContainer, null,
            react_1.default.createElement(RotatingLoader_1.default, null))) : compareProducts.length ? (react_1.default.createElement(styled.Table, null,
            react_1.default.createElement("colgroup", null, Array(columnsNumber).map((el, index) => (react_1.default.createElement(styled.TableCol, { key: index, width: `${100 / columnsNumber}%` })))),
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("th", null),
                    compareProducts.map(product => {
                        const { productLineLogo, partNumber, url, imageUrl, productName } = product;
                        return (react_1.default.createElement("th", { key: product.name },
                            react_1.default.createElement(styled.ColumnHeaderContainer, null,
                                react_1.default.createElement(styled.ColumnControls, null,
                                    react_1.default.createElement(ProductLogo_1.default, { manufacturer: productLineLogo }),
                                    react_1.default.createElement(styled.CloseButton, { "aria-label": t('/haldex/attributes/aria-label/close'), onClick: () => deleteProductFromCompare(partNumber) },
                                        react_1.default.createElement(styled.CrossIcon, { fill: theme.palette.DARK_GRAY_60 }))),
                                react_1.default.createElement(styled.ImageBlock, null,
                                    react_1.default.createElement(ProductImage_1.default, { imageUrl: imageUrl, url: url, productName: productName })),
                                productName && react_1.default.createElement(styled.ProductName, { type: Typography_1.Types.BODY_1 }, productName),
                                partNumber && (react_1.default.createElement(Typography_1.default, { type: Typography_1.Types.BODY_2, color: theme.palette.DARK_GRAY_80 },
                                    t('/haldex/product_page/product/part_number'),
                                    " ",
                                    partNumber)))));
                    }))),
            react_1.default.createElement("tbody", null,
                react_1.default.createElement(styled.TRow, null,
                    react_1.default.createElement(styled.TDataHeader, null,
                        react_1.default.createElement(styled.TDataText, { type: Typography_1.Types.BODY_2, header: true }, t('/haldex/product_page/compare/price_row'))),
                    compareProducts.map((product, index) => (react_1.default.createElement(styled.TDataValues, { key: index },
                        react_1.default.createElement(AddToCartWrapper_1.default, { product: product, listIndex: index, listName: "Product Compare Page" }))))),
                propertyKeys.map(key => (react_1.default.createElement(styled.TRow, { key: key },
                    react_1.default.createElement(styled.TDataHeader, null,
                        react_1.default.createElement(styled.TDataText, { type: Typography_1.Types.BODY_2, header: true }, key)),
                    compareProducts.map(product => {
                        const propertyValue = (0, ProductCompare_utils_1.getPropertyValue)(product, key);
                        return (react_1.default.createElement(styled.TDataValues, { key: `${product.name}-${key}` },
                            react_1.default.createElement(styled.TDataText, { type: Typography_1.Types.BODY_2 }, propertyValue)));
                    }))))))) : (react_1.default.createElement(styled.NoResults, { type: Typography_1.Types.BODY_1 }, t('/haldex/product_page/compare/not_selected')))));
};
exports.default = ProductCompare;
